/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";

import { LocationInterface } from "./UtilsComponents";
import { StyledText, TextSize, TextStatus } from "./Text";
// import Icon from './Icon';
import { useLocation, useNavigate } from "react-router-dom";
import CompetencyNavbar from "./CompetencyNavbar";
import { PillarType } from "../types/Roadmap";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import { CustomDomainBlock } from "../pages/Quest/Domains";
import { getDomainWidth } from "../hooks/generateMobileUi";
import { useScreenClass } from "react-grid-system";
import { UserContext } from "../context/UserContext";
import { CustomBlock, StyledImg } from "./CompetenciesList";
import CompetencyAddModal from "./CompetencyAddModal";
import { CompetencyType } from "../types/Milestone";
import defaultImg from "../assets/DefaultCardImage.png";
import Icon from "@mui/material/Icon";
import { SemesterContext } from "../context/SemesterContext";
import SnackBar from "./SnackBar";
import CompetencyAddModalNew from "./CompetencyAddModalNew";
import { handleJWTError } from "../hooks/jwtErrHandler";
type DomainProps = {
  borderClr: string;
};
const DomainCard = styled(FlexBox) <DomainProps>`
  flex-wrap: nowrap;
  padding: 16px;
  width: auto;
  height: 264px;
  left: 558px;
  top: 164px;
  background: #191b34;
  background: linear-gradient(#191b34 0 0) padding-box,
    /*this is your grey background*/ ${({ borderClr }) => borderClr} border-box;
  border-radius: 8px;
  cursor: pointer;
  border-width: 2px;
  border-style: solid;
  border-image: ${({ borderClr }) => borderClr} 60;
  border: 2px solid ${({ borderClr }) => borderClr};
`;
const StyledHr = styled.hr`
  // width: 100%;
  position: absolute;
  width: 86%;
  bottom: 36px;
  border-color: #3c406c;
  margin-top: 16px;
  margin-bottom: 16px;
`;
function ChildDomains() {
  const navigate = useNavigate();
  let location = useLocation() as LocationInterface;
  const { node, id } = location.state || {};
  const screenClass = useScreenClass();
  const isTablet = useMemo(() => ["md"].includes(screenClass), [screenClass]);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { user } = useContext(UserContext);
  const [selectedCompetency, setSelectedCompetency] = useState<any>({});
  const [breadcrumbData, setBreadcrumbData] = useState<any>([]);
  const [pillars, setPillars] = useState<PillarType>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const semesterContext = useContext(SemesterContext);
  const userContext = useContext(UserContext);
  const storedRole = localStorage.getItem("role");
  const initialRole = JSON.parse(storedRole as string);
  const [stuSelectedVersion, setStuSelectedVersion] = useState<Number>(0);
  const [activeVersion, setActiveVersion] = useState<Number>(0);
  const [message, setMessage] = useState<string>("");
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [warningMessage, setWarningMessage] = useState<any>(null);
  const [warningOpen, setWarningOpen] = useState<boolean>(false);

  const redirectChild = (idChild: string, node: string) => {
    const selectedDomain = pillars.filter((el) => el.id === id)[0];
    const selectedChild = pillars
      .filter((el) => el.id === id)[0]
      .children.filter((el) => el.id === idChild)[0];
    selectedChild &&
      selectedDomain &&
      navigate("/explore/child/competencies", {
        state: {
          id: idChild,
          node,
          parent: selectedDomain,
          child: selectedChild,
        },
      });
  };
  useEffect(() => {
    fetchCompetencies();
  }, [id, semesterContext.selectedSemesterVersion]);
  useEffect(() => {
    updateBreadcrumb(pillars);
    // redirect to the first sub child from /explore/child
    if (pillars.length > 0) {
      const firstDomain = pillars.find((pillar) => pillar.id === id);
      if (firstDomain && firstDomain.children.length > 0) {
        const firstChild = firstDomain.children[0];
        redirectChild(firstChild.id, String(firstChild.node));
      }
    }
  }, [pillars]);
  const fetchCompetencies = () => {
    setLoading(true);
    if (user.role !== 1 && semesterContext.selectedSemesterVersion !== 0) {
      axios
        .get(`/subdomain?curriculum_version=${semesterContext.selectedSemesterVersion}`)
        .then((res) => {
          filterData(res.data.pillars);
        })
        .catch((err) => {
          handleJWTError(err);
        });
    } else if (
      semesterContext.selectedSemester?.label &&
      semesterContext.selectedSemester?.label !== "All" &&
      user.role === 1
    ) {
      axios
        // .get('/subdomain?pretty')
        .get(
          `/student/version?student_id=${initialRole.role_id}&semester_name=${semesterContext.selectedSemester?.label}&program_id=${userContext.user?.programs?.[0]?.id}`
        )
        .then((res) => {
          setStuSelectedVersion(res.data.version.curriculum_version);
          axios
            .get(
              `/subdomain?curriculum_version=${res.data.version.curriculum_version}`
            )
            .then((res) => {
              filterData(res.data.pillars);
            })
            .catch((err) => {
              handleJWTError(err);
            });
        });
    } else if (
      semesterContext.selectedSemester?.label === "All" ||
      user.role !== 1
    ) {
      axios
        .get(`/version?university_code=CMKL`)
        .then((res) => {
          const active_version = res.data.versions.find(
            (v: any) => v.status === "Active Prime"
          ).version_number;
          setActiveVersion(active_version);

          axios
            .get(
              `/subdomain?curriculum_version=${semesterContext.selectedSemesterVersion === 0 ||
                semesterContext.selectedSemester?.label !== "All"
                ? active_version
                : semesterContext.selectedSemesterVersion
              }`
            )
            .then((res1) => {
              filterData(res1.data.pillars);
            })
            .catch((err) => {
              handleJWTError(err);
              setLoading(false);
              setPillars([]);
            });
        })
        .catch((err) => {
          handleJWTError(err);
          setLoading(false);
        });
    } else if (
      // semesterContext.selectedSemester.label === "All" &&
      user.role !== 1 &&
      semesterContext.selectedSemesterVersion !== 0
    ) {
      axios
        .get(`/version?university_code=CMKL`)
        .then((res) => {
          const version_number = res.data.versions.find(
            (v: any) => v.status === "Active Prime"
          ).version_number;
          axios
            .get(`/subdomain?curriculum_version=${semesterContext.selectedSemesterVersion}`)
            .then((res1) => {
              filterData(res1.data.pillars);
            })
            .catch((err) => {
              setLoading(false);
              setPillars([]);
            });
        })
        .catch((err) => {
          handleJWTError(err);
        });
    } else {
      axios
        .get(`/subdomain`)
        .then((res) => {
          filterData(res.data.pillars);
        })
        .catch((err) => {
          handleJWTError(err);
        });
    }
  };
  const filterData = (data: any) => {
    const custom: PillarType = [];
    data.forEach((element: any, index: any) => {
      custom.push({
        id: element.id,
        node: index + 1,
        label: element.title,
        description: element.description,
        iconBg: element.graphics.iconbg,
        borderColor: element.graphics.bordercolor,
        icon: element.graphics.icon,
        iconShadow: element.graphics.iconshadow,
        children: [],
      });
      if (element.subdomains && element.subdomains.length > 0) {
        element.subdomains.forEach((elementChild: any, indexChild: any) => {
          custom[index].children.push({
            id: elementChild.id,
            node: Number(
              String(data.length) + String(index + 1) + String(indexChild + 1)
            ),
            label: elementChild.title,
            count: "0/7",
            icon: "",
            description: elementChild.description,
          });
        });
      }
    });
    setPillars(custom);
    setLoading(false);
  };
  const updateBreadcrumb = (data: any) => {
    const selected = data.filter((el: { id: string }) => el.id === id)[0];
    setBreadcrumbData([
      { link: "/explore/child", name: selected?.label, ...selected },
    ]);
  };
  const searchCompetencies = (searchVal: string) => {
    if (!searchVal || searchVal === "") {
      setShowFilter(false);
    } else {
      let axiosStr = "/competency/summary?university_code=CMKL";
      if (user.role !== 1 || semesterContext.selectedSemester?.label === "All") {
        axiosStr =
          semesterContext.selectedSemester?.label &&
          `/competency/summary?university_code=CMKL&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ||
            semesterContext.selectedSemester?.label !== "All"
            ? activeVersion
            : semesterContext.selectedSemesterVersion
          }`;
      }
      // else if (semesterContext.selectedSemester.label === "All") {
      //   axiosStr = `/competency/summary?university_code=CMKL&curriculum_version=${
      //     semesterContext.selectedSemesterVersion === 0 ? activeVersion : semesterContext.selectedSemesterVersion
      //   }`;
      // }
      else {
        axiosStr = `/competency/summary?university_code=CMKL&curriculum_version=${stuSelectedVersion}&semester_name=${semesterContext.selectedSemester?.label}`;
      }
      axios
        .get(axiosStr)
        .then((res) => {
          if (res.data.competencies) {
            if (res.data.competencies && res.data.competencies.length > 0) {
              let searchArray = searchVal.trim().split(" ");
              let re = new RegExp(searchArray.join("|"), "i");
              // let resultsObj = res.data.competencies.filter(
              //   (competencyItem: CompetencyType) =>
              //     re.test(competencyItem.competency_code) ||
              //     re.test(competencyItem.title)
              // );
              let resultsObj = res.data.competencies.filter(
                (competencyItem: CompetencyType) =>
                  competencyItem.competency_code
                    .toLowerCase()
                    .includes(searchVal.toLowerCase()) ||
                  competencyItem.title
                    .toLowerCase()
                    .includes(searchVal.toLowerCase())
              );
              setCompetencies(resultsObj);
            } else {
              setCompetencies([]);
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          handleJWTError(err);
          setCompetencies([]);
          setLoading(false);
        });
      setShowFilter(true);
    }
  };

  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
        link
      />

      {isModalOpen && (
        <CompetencyAddModalNew
          isWarningOpen={warningOpen}
          setIsWarningOpen={setWarningOpen}
          fetchCompetency={() => fetchCompetencies}
          setMessage={setMessage}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setWarningMessage={setWarningMessage}
          setWarningOpen={setWarningOpen}
          isStudent={user.role === 1}
          isAddModalOpen={isModalOpen}
          setAddModalOpen={setIsModalOpen}
          data={selectedCompetency}
          onAddComplete={() => { }}
          onAddError={() => { }}
        />
      )}
      <CompetencyNavbar
        breadcrumb={breadcrumbData}
        searchCompetency={searchCompetencies}
        clearSearch={() => {
          fetchCompetencies();
        }}
      />
      {!showFilter ? (
        <FlexBox style={{ marginRight: "-8px" }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              {pillars
                .filter((el) => el.id === id)[0]
                ?.children.map((item: any, index) => (
                  <CustomDomainBlock
                    key={index}
                    blockWidth={getDomainWidth(isMobile, isTablet)}
                  >
                    <DomainCard
                      direction="column"
                      alignItems="flex-start"
                      onClick={() => {
                        redirectChild(item.id, item.node);
                      }}
                      borderClr={pillars.filter((el) => el.id === id)[0].iconBg}
                    >
                      {/* <Icon size={4} fixedWidth={false} name={item.icon} />
                    <MuiIcon>{item.icon}</MuiIcon> */}
                      <FlexGrow style={{ flexGrow: "0" }}>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                          style={{ textTransform: "uppercase" }}
                        >
                          {item.label}
                        </StyledText>
                      </FlexGrow>
                      <FlexGrow style={{ overflow: "hidden" }}>
                        <StyledText
                          status={TextStatus.muted}
                          textSize={TextSize.default}
                          fontWeight="normal"
                        >
                          {item.description}
                        </StyledText>
                      </FlexGrow>
                    </DomainCard>
                  </CustomDomainBlock>
                ))}
            </>
          )}
        </FlexBox>
      ) : (
        <FlexBox
          space={1}
          alignItems="flex-start"
          style={{
            marginRight: "-16px",
            minHeight: "60vh",
          }}
        >
          {competencies.length > 0 ? (
            competencies.map((competency: any) => (
              <>
                <CustomBlock
                  backgroundColor={
                    competency.graphics ? competency.graphics.iconbg : "red"
                  }
                  onClick={() => {
                    setSelectedCompetency(competency);
                    setIsModalOpen(true);
                  }}
                >
                  <div style={{ padding: "5px 0px", fontWeight: "bold" }}>
                    {competency.competency_code}
                  </div>
                  <StyledImg
                    src={
                      competency.graphics && competency.graphics.imgurl
                        ? process.env.REACT_APP_IMG_URL +
                        competency.graphics.imgurl
                        : defaultImg
                    }
                    alt=""
                  />
                  <Icon
                    sx={{
                      color: "white",
                      padding: "6px",
                      background: competency.graphics
                        ? competency.graphics.iconbg
                        : "red",
                      borderRadius: "100px",
                      fontSize: "27px",
                      position: "absolute",
                      left: "50%",
                      bottom: "105px",
                      transform: "translateX(-50%)",
                      boxShadow: competency.graphics
                        ? competency.graphics.iconshadow
                        : "black",
                    }}
                  >
                    {competency.graphics ? competency.graphics.icon : "help"}
                  </Icon>
                  <StyledText fontWeight="700">{competency.title}</StyledText>
                </CustomBlock>
              </>
            ))
          ) : (
            <FlexGrow style={{ textAlign: "center" }}>
              <StyledText
                color="red"
                fontWeight="700"
                textSize={TextSize.default}
              >
                No matching competency found.
              </StyledText>
            </FlexGrow>
          )}
        </FlexBox>
      )}
    </>
  );
}
export default ChildDomains;
